(() => {
  if (window.keliGalleryNav) return;
  window.keliGalleryNav = true;

  const desktop = window.matchMedia('(min-width: 750px)');

  // Pin the arrows to the displayed image's edges; with media_fit: contain the active
  // image can be narrower than the media column, and each media item has its own ratio.
  const position = (gallery) => {
    if (!desktop.matches) return;
    const slider = gallery.querySelector("slider-component[id^='GalleryViewer']");
    const container = gallery.querySelector('.product__media-item.is-active .product-media-container');
    const previous = gallery.querySelector('.keli-gallery-nav--prev');
    const next = gallery.querySelector('.keli-gallery-nav--next');
    if (!slider || !container || !previous || !next) return;
    const sliderRect = slider.getBoundingClientRect();
    const rect = container.getBoundingClientRect();
    previous.style.left = `${Math.max(rect.left - sliderRect.left, 0)}px`;
    previous.style.right = 'auto';
    next.style.right = `${Math.max(sliderRect.right - rect.right, 0)}px`;
    next.style.left = 'auto';
  };

  // Coalesce bursts of layout reads (resize, multi-class media switches) into one frame.
  let frame = null;
  const positionAll = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      document.querySelectorAll('media-gallery').forEach(position);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.keli-gallery-nav');
    if (!button) return;
    const gallery = button.closest('media-gallery');
    if (!gallery) return;
    const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list .thumbnail'));
    if (thumbnails.length < 2) return;
    const current = thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
    const direction = Number(button.dataset.direction) || 1;
    const targetIndex = (current + direction + thumbnails.length) % thumbnails.length;
    thumbnails[targetIndex].click();
    positionAll();
  });

  window.addEventListener('resize', positionAll);

  // Observe each gallery's media list so the arrows follow active-media changes from any
  // source (thumbnail click, variant swap). A body observer also picks up galleries added
  // after load (section re-render, app injection), so late galleries are covered too.
  const observed = new WeakSet();
  const observeGalleries = () => {
    document.querySelectorAll('media-gallery .product__media-list').forEach((list) => {
      if (observed.has(list)) return;
      observed.add(list);
      new MutationObserver(positionAll).observe(list, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    });
  };

  observeGalleries();
  new MutationObserver(observeGalleries).observe(document.body, { childList: true, subtree: true });
  positionAll();
})();
